import { axiosPost } from "../options/header";

const changeCaseExpirationValue = (case_id, thirty_day_end) => {
    try {
        return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/"+case_id+"/client-portal", {
          params: {
            thirty_day_end
          },
          
  
        });
      } catch {
        console.log("Failed attempt at group.");
      }
};
export {
    changeCaseExpirationValue
}